import { connect } from 'react-redux';
import { getDeviationPatchedWithStoreState } from '../../../../CollectionPanel/redux/selectors';
import { changeFaveCustom } from '../../../../CollectionPanel/redux/actionCreators';
import { getVisiblePanel } from '../../../../DeviationPage/redux/selectors';
import { togglePanel } from '../../../../DeviationPage/redux/actions';
const mapStateToProps = (state, { deviation, actionBarType })=>{
    const patchedDeviation = getDeviationPatchedWithStoreState(state, deviation);
    return {
        deviation: patchedDeviation,
        isCollectionPanelOpen: getVisiblePanel(state, actionBarType) === 'collection'
    };
};
const mapDispatchToProps = {
    onToggleCollectionPanel: togglePanel.bind(null, 'collection'),
    onChangeFave: changeFaveCustom
};
export default connect(mapStateToProps, mapDispatchToProps);
